module.exports = __webpack_public_path__ + "img/hr-carousel-background-large.c09c6666.png";